var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.765,
    height: 35.162,
    viewBox: "0 0 328.765 35.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(24 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_49",
    "data-name": "Union 49",
    d: "M8011.32,12288.114l-.013-.011v.025c-22.829,0-53.6,12.858-73.106,12.858-2.664-1.643-15.615-4.6-15.615-17.562,0-12.361,13.8-12.361,15.723-17.578,15.367,0,50.888,12.878,73,12.879l.016-.016c22.826,0,53.6-12.86,73.106-12.86,2.661,1.643,15.615,4.6,15.615,17.563,0,12.361-13.8,12.361-15.726,17.578C8068.95,12300.99,8033.423,12288.114,8011.32,12288.114Z",
    transform: "translate(-7797.2 -12145.83)",
    fill: "#d9000d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_50",
    "data-name": "Union 50",
    d: "M7922.585,12283.427c0-12.364,13.8-12.364,15.726-17.578,15.364,0,50.888,12.874,72.992,12.876l.016-.016c22.83,0,54.059-12.86,73.561-12.86,2.664,1.646,15.161,4.6,15.161,17.563,0,12.364-13,12.349-14.929,17.563-15.365,0-51.688-12.861-73.792-12.861l-.012-.01v.025c-22.83,0-53.605,12.861-73.107,12.861C7935.536,12299.344,7922.585,12296.39,7922.585,12283.427Z",
    transform: "translate(-7945.2 -12145.83)",
    fill: "#a10308"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 17.581,
    cy: 17.581,
    r: 17.581,
    transform: "translate(-24 120)",
    fill: "#a10308"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    transform: "translate(269.603 120)",
    fill: "#fff",
    stroke: "#ed1d24",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.581,
    cy: 17.581,
    r: 17.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.581,
    cy: 17.581,
    r: 17.081,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 17.581,
    cy: 17.581,
    r: 17.581,
    transform: "translate(122.802 120)",
    fill: "#d9000d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-7.046 143.882)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.822,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(140.085 144.247)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.274,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(286.784 144.247)",
    fill: "#ed1d24",
    fontSize: 19,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.274,
    y: 0
  }, "3")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.15306ef838e193943682e7b3d7d4fef8.svg";
export { ForwardRef as ReactComponent };